import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {

  private hubConnection!: signalR.HubConnection;
  private messageSubject = new BehaviorSubject<string | null>(null);
  public messages$ = this.messageSubject.asObservable();

constructor() { }

startConnection(webSocketUrl: string) {
  const hubConnection = new signalR.HubConnectionBuilder()
    .withUrl(webSocketUrl, {  transport: signalR.HttpTransportType.WebSockets}).build();

    hubConnection
    .start()
    .then(() => { console.log('WebSocket connection established', hubConnection)})
    .catch(err => {console.error('Error while starting WebSocket connection:', err); });

    hubConnection.on('ConversationLiveStreaming', (message: any) => {
    console.log('Message received:', message);
    this.messageSubject.next(message);
  });
  hubConnection.onclose(() => {
    console.log('WebSocket connection closed');
  });
  }

  sendMessage(webSocketUrl: string) {
    if (this.hubConnection) {
      this.hubConnection.invoke('SendMessage', webSocketUrl).catch(err => {
        console.error('Error sending message to SignalR:', err);
      });
    }
  }

  stopConnection() {
    this.hubConnection.stop().then(() => console.log('SignalR Connection Stopped'));
  }
}
